import { isUndefined } from "lodash";
import React from "react";
import { numberWithCommas } from "../../../helpers/dataHelpers";

import _ from "lodash";
import { Badge } from "react-bootstrap";

const makeid = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const renderScope = (scope) => {
  switch (scope) {
    case "All":
      return { header: "Cluster Name", accessor: "clusterName" };

    case "Cluster":
      return { header: "Area Name", accessor: "areaName" };

    case "Area":
      return { header: "Area Name", accessor: "areaName" };

    case "Branch":
      return { header: "Branch Name", accessor: "branchName" };

    default:
      return { header: "clusterName", accessor: "clusterName" };
  }
};

const newPawnDetailsColumnsCharges = (data) => {
  var tempList = [];
  return data
    .map((item) =>
      item.newPawnDetails.charges.map((key, idx) => {
        if (!tempList.includes(key.name)) {
          tempList.push(key.name);
          return {
            id: makeid(5),
            className: "newPawns",
            Header: key.name,
            accessor: (d) => {
              var amount =
                d.newPawnDetails.charges.length > 0 &&
                Array.isArray(d.newPawnDetails.charges) &&
                !isUndefined(
                  _.find(d.newPawnDetails.charges, ["name", key.name])
                )
                  ? _.find(d.newPawnDetails.charges, ["name", key.name]).amount
                  : 0;

              return (
                <span className="float-right">
                  {numberWithCommas(amount, 2)}
                </span>
              );
            },
          };
        } else {
          return {
            Header: null,
          };
        }
      })
    )
    .reduce((prev, curr) => prev.concat(curr), [])
    .filter((item, i, arr) => arr.indexOf(item) === i && item.Header !== null);
};

const newPawnDetailsColumnsDiscounts = (data) => {
  var tempList = [];
  return data
    .map((item) =>
      item.newPawnDetails.discounts.map((key, idx) => {
        if (!tempList.includes(key.name)) {
          tempList.push(key.name);

          return {
            id: makeid(5),
            className: "newPawns",
            Header: key.name,
            accessor: (d) => {
              var amount =
                d.newPawnDetails.discounts.length > 0 &&
                Array.isArray(d.newPawnDetails.discounts) &&
                !isUndefined(
                  _.find(d.newPawnDetails.discounts, ["name", key.name])
                )
                  ? _.find(d.newPawnDetails.discounts, ["name", key.name])
                      .amount
                  : 0;
              return (
                <span className="float-right">
                  {numberWithCommas(amount, 2)}
                </span>
              );
            },
          };
        } else {
          return {
            Header: null,
          };
        }
      })
    )
    .reduce((prev, curr) => prev.concat(curr), [])
    .filter((item, i, arr) => arr.indexOf(item) === i && item.Header !== null);
};

const redeemedDetailsColumnsCharges = (data) => {
  var tempList = [];
  return data
    .map((item) =>
      item.redeemedDetails.charges.map((key, idx) => {
        if (!tempList.includes(key.name)) {
          tempList.push(key.name);
          return {
            id: makeid(5),
            className: "redeemedPawns",
            Header: key.name,
            accessor: (d) => {
              var amount =
                d.redeemedDetails.charges.length > 0 &&
                Array.isArray(d.redeemedDetails.charges) &&
                !isUndefined(
                  _.find(d.redeemedDetails.charges, ["name", key.name])
                )
                  ? _.find(d.redeemedDetails.charges, ["name", key.name]).amount
                  : 0;

              return (
                <span className="float-right">
                  {numberWithCommas(amount, 2)}
                </span>
              );
            },
          };
        } else {
          return {
            Header: null,
          };
        }
      })
    )
    .reduce((prev, curr) => prev.concat(curr), [])
    .filter((item, i, arr) => arr.indexOf(item) === i && item.Header !== null);
};

const redeemedDetailsColumnsDiscounts = (data) => {
  var tempList = [];
  return data
    .map((item) =>
      item.redeemedDetails.discounts.map((key, idx) => {
        if (!tempList.includes(key.name)) {
          tempList.push(key.name);

          return {
            id: makeid(5),
            className: "redeemedPawns",
            Header: key.name,
            accessor: (d) => {
              var amount =
                d.redeemedDetails.discounts.length > 0 &&
                Array.isArray(d.redeemedDetails.discounts) &&
                !isUndefined(
                  _.find(d.redeemedDetails.discounts, ["name", key.name])
                )
                  ? _.find(d.redeemedDetails.discounts, ["name", key.name])
                      .amount
                  : 0;

              return (
                <span className="float-right">
                  {numberWithCommas(amount, 2)}
                </span>
              );
            },
          };
        } else {
          return {
            Header: null,
          };
        }
      })
    )
    .reduce((prev, curr) => prev.concat(curr), [])
    .filter((item, i, arr) => arr.indexOf(item) === i && item.Header !== null);
};

export const RenderClusterColumns = (list, scope) => {
  const columns = [
    {
      Header: renderScope(scope).header,
      accessor: (r) => {
        let code = " ";
        let name = " ";
        switch (scope) {
          case "All":
            code = r.clusterCode;
            name = r.clusterName;
            break;

          case "Cluster":
            code = r.areaCode;
            name = r.areaName;
            break;

          case "Area":
            code = r.areaCode;
            name = r.areaName;
            break;

          case "Branch":
            code = r.branchCode;
            name = r.branchName;
            break;

          default:
            code = r.clusterCode;
            name = r.clusterName;
            break;
        }
        return (
          <span>
            {`${name} ${" "}`}
            {scope !== "Branch" && (
              <Badge pill size="sm" variant="dark">
                {code}
              </Badge>
            )}
          </span>
        );
      },
      // accessor: renderScope(scope).accessor,
      // renderCode: renderScope(scope).renderCode,
      Footer: "Total",
    },
    // {
    //   Header: "# Branches",
    //   accessor: "branchCount",
    //   Footer: 1,
    // },
    {
      Header: "New Pawn",
      className: "newPawns",
      columns: [
        {
          id: makeid(5),
          Header: "Charges",
          className: "newPawns",
          accessor: (r) => {
            return r.newPawnDetails.charges;
          },
          columns: newPawnDetailsColumnsCharges(list),
        },
        {
          id: makeid(5),
          Header: "Discounts",
          className: "newPawns",
          accessor: (r) => {
            return r.newPawnDetails.discounts;
          },
          columns: newPawnDetailsColumnsDiscounts(list),
        },
      ],
    },
    {
      Header: "Redeemed Pawn",
      className: "redeemedPawns",
      columns: [
        {
          id: makeid(5),
          Header: "Charges",
          className: "redeemedPawns",
          accessor: (r) => {
            return r.redeemedDetails.charges;
          },
          columns: redeemedDetailsColumnsCharges(list),
        },
        {
          id: makeid(5),
          Header: "Discounts",
          className: "redeemedPawns",
          accessor: (r) => {
            return r.redeemedDetails.discounts;
          },
          columns: redeemedDetailsColumnsDiscounts(list),
        },
      ],
    },
    {
      Header: "Profit Pawn",
      accessor: (r) => (
        <span className="float-right">
          {numberWithCommas(r.newPawnDetails.profit, 2)}
        </span>
      ),
    },
    {
      Header: "Profit Redeem",
      accessor: (r) => (
        <span className="float-right">
          {numberWithCommas(r.redeemedDetails.profit, 2)}
        </span>
      ),
    },
    {
      Header: "Total Profit",
      accessor: (r) => (
        <span className="float-right">
          {numberWithCommas(r.totalProfit, 2)}
        </span>
      ),
    },
  ];

  if (scope === "Branch") {
    columns.unshift({
      Header: "Branch Code",
      accessor: (r) => r.branchCode,
      Footer: "TOTAL",
    });
  }

  return columns;
};
